// Leitura do storage compartilhado que o Angular escreve no login (mesma origem).
// Espelha o que o AuthInterceptor injeta nos headers. Apenas leitura: o Angular
// segue dono da escrita (login/refresh). Decodificação defensiva (nunca lança) e
// sem cache, para refletir o refresh de token feito pelo Angular.
//
// Constantes abaixo = "contrato de storage": a fronteira de acoplamento com o
// Angular. Quando o Angular sair, só muda quem escreve essas keys.
export const TOKEN_KEY = 'token';
export const TENANT_KEY = 'tenant';
export const TENANT_SCHEMA_KEY = 'tenant_schema';
export const LOCALE_KEY = 'locale';
export const TIMEZONE_KEY = 'timezone';

const DEFAULT_LOCALE = 'pt_BR';

/** access_token de sessionStorage['token']; null se ausente/malformado. */
export function getAccessToken(): string | null {
  try {
    const raw = sessionStorage.getItem(TOKEN_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as { access_token?: string } | null;
    return parsed && parsed.access_token ? parsed.access_token : null;
  } catch {
    return null;
  }
}

/**
 * Header `tenant` espelhando a regra XOR do AuthInterceptor: schema-only quando
 * exatamente uma fonte está presente; null quando ambas ou nenhuma.
 */
export function getTenantHeader(): string | null {
  const schema = getTenantSchema();
  const tenant = getTenantObject();

  if (!schema && tenant && tenant.schema) {
    return tenant.schema;
  }
  if (schema && !tenant) {
    return schema;
  }
  return null;
}

/** locale de localStorage['locale']; fallback 'pt_BR'. */
export function getLocale(): string {
  try {
    const value = localStorage.getItem(LOCALE_KEY);
    return value && value.length ? value : DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
}

/** timezone de sessionStorage['timezone'] (JSON); null se ausente/inválido. */
export function getTimeZone(): string | null {
  try {
    const raw = sessionStorage.getItem(TIMEZONE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as unknown;
    return typeof parsed === 'string' && parsed.length ? parsed : null;
  } catch {
    return null;
  }
}

// tenant é armazenado como base64(JSON) pelo Angular; tenant_schema é string simples.
function getTenantSchema(): string | null {
  try {
    const value = sessionStorage.getItem(TENANT_SCHEMA_KEY);
    return value && value.length ? value : null;
  } catch {
    return null;
  }
}

function getTenantObject(): { schema?: string } | null {
  try {
    const raw = sessionStorage.getItem(TENANT_KEY);
    if (!raw) {
      return null;
    }
    const decoded = atob(raw);
    return decoded ? (JSON.parse(decoded) as { schema?: string }) : null;
  } catch {
    return null;
  }
}
